export const payload = {
  receiveMutation: 'RECEIVE_PAYMENTS',
  receivingMutation: 'RECEIVING_PAYMENTS',
  receiveMetadataMutation: 'RECEIVE_PAYMENT_METADATA',
  receiveFailureMutation: 'RECEIVE_PAYMENT_FAILURE',
  savingMutation: 'SAVING_PAYMENT',
  saveFailureMutation: 'SAVING_PAYMENT_FAILURE',
  incrementMutation: 'INCREMENT_PAYMENT_COUNT',
  updatingMutation: 'UPDATING_PAYMENT',
  updateFailureMutation: 'UPDATING_PAYMENT_FAILURE',
  deleteMutation: 'DELETE_PAYMENT',
  deletingMutation: 'DELETING_PAYMENT',
  deleteFailureMutation: 'DELETING_PAYMENT_FAILURE',
  resetMetaMutation: 'RESET_BUDGET_META',
  clearMutation: 'CLEAR_PAYMENT_STATE',
  moduleName: 'payment',
  endpoint: 'payments'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Payments/actionPayload.js